import React from "react";
import SquareButton from "../../ui/SquareButton";
import AddIcon from "@material-ui/icons/Add";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  menuStyles: {
    "& ul": {
      padding: 0
    },
    "& > .MuiPaper-root": {
      top: "170px !important",
      marginLeft: -90
    },
    padding: 0
  },
  itemStyles: {
    fontSize: "12px",
    padding: "17px"
  }
});

const AddButton = ({ onClick, actions }) => {
  const { menuStyles, itemStyles } = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (action) => {
    setAnchorEl(null);
    typeof action === 'function' && action();
  };

  return (
    <div>
      <SquareButton onClick={actions ? handleClick : onClick}>
        <AddIcon fontSize="small" />
      </SquareButton>
      {(actions && actions.length > 0) &&
        <Menu
            className={menuStyles}
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
          >
            {actions.map(({ label, onClick, disabled }) => (
              <MenuItem
                key={label}
                onClick={() => handleClose(onClick)}
                className={itemStyles}
                disabled={disabled}
              >
                {label}
              </MenuItem>
            ))}
          </Menu>}
    </div>
  );
};

export default AddButton;
